import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyDRv8KMO70C9dz9IjG6mEXgNk9QDTV88To",
  authDomain: "breagy1.firebaseapp.com",
  databaseURL: "https://breagy1.firebaseio.com",
  projectId: "breagy1",
  storageBucket: "breagy1.appspot.com",
  messagingSenderId: "258707441482"
};
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore()

// firebase collections
const messagesCollection = db.collection('messages')

export {
    db,
    messagesCollection,
}